import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import { deepClone } from '../../../utils/clone'

import { HealthServiceDataViewStatus } from './HealthStatusService'

const HealthStatusServiceJuno = ({ data, nodeName }) => {

    const tab_col = [
        {
            field: "id",
            headerName: "Account ID",
            minWidth: 150,
            suppressSizeToFit: true,
            checkboxSelection: true
        },
        {
            field: "status",
            headerName: "Status",
            cellStyle: function (params) {
                if (params.value === 'blacklisted') {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                } else if (params.value === 'dl') {
                    return { color: 'black', backgroundColor: '#FFFF66' };
                } else if (params.value !== 'up') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            },
            minWidth: 200,
        },
    ]

    const [tab_data, settab_data] = useState([])

    useEffect(() => {
        settab_data(Object.keys(data).sort((a, b) => (data[a].status === 'up') ? 1 : -1).reduce((rowData, rowId) => {

            const row = deepClone(data[rowId])

            rowData.push({
                'uniqueId': row.id,
                'id': row.id,
                'status': row.status,
                'detailView': {
                    'head': {
                    },
                    'data': [
                        {
                            'type': 'account_detail',
                            'subheader': 'Account',
                            'content': {
                                'accountId': row.id,
                            }
                        },
                        {
                            'type': 'graph_account',
                            'subheader': 'Hierachy',
                            'content': {
                                'accountId': row.id,
                            },
                        },
                    ],
                },
            })
            return rowData
        }, []))
        return () => {
            settab_data([])
        }
    }, [data])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Box direction="row">
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Accounts </Text>
                <HealthServiceDataViewStatus tab_data={tab_data.map(function (item) { return item["status"] })} />
            </Box>

            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="HealthStatusServiceJuno2"
                defaultSubTab="Account"
                countTitle="Accounts"
                selection="multiple"
                nodeName={nodeName}
                tableHeight={700}
            />

        </Box>
    )
}

export default HealthStatusServiceJuno
